import { useCallback, useRef, useState } from "react";
import { Icon } from "@/components/lib";

type SearchProps = {
  throttle?: number;
  callback: (value: string) => void;
  placeholder?: string;
  className?: string;
  clear?: boolean;
};

const SearchInputApi = (props: SearchProps) => {
  const timeoutRef = useRef(null);
  const [selected, setSelected] = useState("");

  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSelected(value);

      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(async () => {
        props.callback(value);
      }, props.throttle || 1000);
    },
    [props]
  );

  return (
    <div className={props.className}>
      <Icon image="search" className="w-5 h-5" />
      <input
        type="text"
        value={selected}
        placeholder={props.placeholder}
        onChange={handleSearch}
        className="w-full bg-transparent focus:outline-none"
      />
      {selected && (
        <button
          onClick={() => {
            setSelected("");
            props.callback("");
          }}
          className="ml-auto pt-0.5"
        >
          <Icon image="x" />
        </button>
      )}
    </div>
  );
};

export default SearchInputApi;
